export default __webpack_public_path__ + "static/media/logo-red.eb23c7a1.svg";